import { combineReducers } from "@reduxjs/toolkit";
import { routeReducer } from "./RouteReducer";
import { errorReducer } from "./ErrorReducer";
import loadingReducer from "./LoadingReducer";
import reviewReducer from "./ReviewReducer";

const rootReducer = combineReducers({
    routes: routeReducer,
    error: errorReducer,
    loading: loadingReducer,
    review: reviewReducer
});

export default rootReducer;